import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Input
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardLabGroupUX = (props: any) => {
    return(
      <div>
        <div
          id="CardLabGroup-div-1"
          style={{padding: "15px 10px" }}>
          
          <label
            id="CardLabGroup-label-12"
            style={{fontWeight: "bold", fontSize: "1.4rem", padding: "1rem"}}>
            {props.languageUX === "en" ? "Lab set" : "Lab ชุด"}
          </label>
          <div
            id="CardLabGroup-div-2"
            style={{display: "flex", alignItems: "center" }}>
            
            <div
              id="CardLabGroup-div-3"
              style={{marginLeft: "auto"}}>
              
            </div>
            <Input
              id="CardLabGroup-Input-6"
              onChange={props.labGroupSearchChange}
              onKeyDown={(e: any) => { e.key === "Enter" && props.searchLabGroup(); }}
              style={{marginLeft: "15px"}}
              value={props.labGroupSearch}>
            </Input>
            <Button
              color="blue"
              id="CardLabGroup-Button-5"
              onClick={props.labGroupSearchBtn}
              style={{marginLeft: "15px"}}>
              {props.languageUX === "en" ? "Search" : "ค้นหา"}
            </Button>
            <Button
              color="orange"
              id="CardLabGroup-Button-7"
              onClick={props.labGroupManageBtn}
              style={{marginLeft: "15px", marginRight: "10px"}}>
              จัดการชุด Lab 
            </Button>
          </div>
          <div
            id="CardLabGroup-div-8">
            
            <Table
              data={props.labGroupItems}
              headers=" ,ชื่อชุด Lab,รายการ"
              id="CardLabGroup-Table-9"
              keys="check,name,detail"
              minRows="5"
              showPagination={false}
              style={{height: "300px", margin: "10px",fontSize: "1.2rem",}}
              widths="90,300,auto">
            </Table>
          </div>
          <div
            id="CardLabGroup-div-10">
            
            <Button
              color="blue"
              id="CardLabGroup-Button-11"
              onClick={props.labGroupSelectedBtn}
              style={{width: "150px", marginLeft: "10px"}}>
              {props.languageUX === "en" ? "choose" : "เลือก"}
            </Button>
          </div>
        </div>
      </div>
    )
}


export default CardLabGroupUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:03:08 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabGroup-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"15px 10px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabGroup-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabGroup-div-3"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"auto\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardLabGroup-Button-5"
        },
        "onClick": {
          "type": "code",
          "value": "props.labGroupSearchBtn"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"15px\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Input",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabGroup-Input-6"
        },
        "onChange": {
          "type": "code",
          "value": "props.labGroupSearchChange"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => { e.key === \"Enter\" && props.searchLabGroup(); }"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"15px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.labGroupSearch"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "จัดการชุด Lab "
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardLabGroup-Button-7"
        },
        "onClick": {
          "type": "code",
          "value": "props.labGroupManageBtn"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"15px\", marginRight: \"10px\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabGroup-div-8"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 9,
      "name": "Table",
      "parent": 8,
      "props": {
        "data": {
          "type": "code",
          "value": "props.labGroupItems"
        },
        "headers": {
          "type": "value",
          "value": " ,ชื่อชุด Lab,รายการ"
        },
        "id": {
          "type": "value",
          "value": "CardLabGroup-Table-9"
        },
        "keys": {
          "type": "value",
          "value": "check,name,detail"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"300px\", margin: \"10px\",fontSize: \"1.2rem\",}"
        },
        "widths": {
          "type": "value",
          "value": "90,300,auto"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabGroup-div-10"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Button",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก",
          "valueEN": "choose"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardLabGroup-Button-11"
        },
        "onClick": {
          "type": "code",
          "value": "props.labGroupSelectedBtn"
        },
        "style": {
          "type": "code",
          "value": "{width: \"150px\", marginLeft: \"10px\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "Lab ชุด",
          "valueEN": "Lab set"
        },
        "id": {
          "type": "value",
          "value": "CardLabGroup-label-12"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.4rem\", padding: \"1rem\"}"
        }
      },
      "seq": 2,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardLabGroupUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
